import { Store, Module, ActionContext, MutationTree } from 'vuex'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface ComplaintState {
    loading: boolean;
}
class ComplaintModule implements Module<ComplaintState, any>{
    namespaced = true;
    state = {
        loading: false,
    }
    actions = {
        async send(context: ActionContext<ComplaintState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/complaint', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
    };
    mutations = {
        
    };
}
const complaintModule = new ComplaintModule();
export default complaintModule;